import { useContext, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { currentUserEmailAtom } from '@shared/state/authState';
import { AuthContext } from '@app/providers/firebase/AuthProvider';

export const AuthStateSync = () => {
  const { userEmail } = useContext(AuthContext);
  const setCurrentUserEmail = useSetRecoilState(currentUserEmailAtom);

  useEffect(() => {
    setCurrentUserEmail(userEmail);
  }, [userEmail, setCurrentUserEmail]);

  return null;
}; 